module.exports = __webpack_public_path__ + "img/dsci0052.af67e82f.jpg";